import { Box } from '@mui/material';
import { MFSubmitButton } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Location } from 'history';
import { IsInvestorWithPAN } from '../../utils/utilityFunctions';
import { FLOW_TYPE_MASTER } from '../../utils/constant';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';

interface Values {
  flowType: string;
}

export default function Onboard({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
  }>;
}): JSX.Element {
  const { application } = location.state || {};
  const { applicants = [] } = application || {};
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const validationSchema1 = yup.object().shape({
    flowType: yup.string().nullable().required('Flow Type is required'),
  });
  const initialValues: Values = {
    flowType: '',
  };

  const handleSubmit1 = async (values: Values) => {
    try {
      const { flowType = '' } = values;
      const locationHistory = {
        ...(values || {}),
        redirectTo: 'start',
      };
      return history.push(
        IsInvestorWithPAN(flowType) ? `enter-pan-number` : 'enter-tax-id-number',
        locationHistory
      );
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema1}
      enableReinitialize={true}
      onSubmit={handleSubmit1}>
      {({ handleSubmit }) => (
        <>
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Box sx={{ mt: 1.5 }}>
              <UseRadioGroup
                formLabel="Flow Type"
                name={`flowType`}
                items={Object.keys(FLOW_TYPE_MASTER).map((option) => ({
                  label: FLOW_TYPE_MASTER[option],
                  value: option,
                }))}
              />
            </Box>
            <MFSubmitButton label="Proceed" />
          </Box>
        </>
      )}
    </Formik>
  );
}
